
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Задания на обзвон', path: '/amo-crm/tasks' },
            { id: 2, name: 'AmoCRM', path: '/amo-crm/customers' },
            { id: 3, name: 'Whatsapp', path: '/amo-crm/whatsapp' },
            { id: 4, name: 'Черный список', path: '/amo-crm/blacklist' }
        ]

        return { tabs }
    },
})
